<template>
  <el-form
    :model="form.data"
    :rules="form.rules"
    ref="data-form"
    :label-width="labelWidth + 'px'"
  >
    <el-form-item
      v-for="(field,i) of showForm ? fields : []"
      v-show="calculateShow(field.show, form.data)"
      :key="i"
      :label="field.lable"
      :prop="field.id"
    >
      <!--   日期     -->
      <el-date-picker
        v-if="field.type == 'date'"
        type="date"
        placeholder="选择日期"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        :title="field.placeholder"
        style="width: 200px;"
        v-model="form.data[field.id]"
        :disabled="field.disabled"
        @change="field.change ? field.change(form.data) : ''"
      />
      <!--   时间     -->
      <el-date-picker
        v-else-if="field.type == 'time'"
        v-model="form.data[field.id]"
        :title="field.placeholder"
        type="datetime"
        placeholder="选择日期时间"
        :disabled="field.disabled"
        align="right"
        value-format="yyyy-MM-dd HH:mm:ss"
        style="width: 200px;"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <!--    开关选择    -->
      <el-switch
        v-else-if="field.type == 'switch'"
        :title="field.placeholder"
        :disabled="field.disabled"
        v-model="form.data[field.id]"
      />
      <!--    单选框    -->
      <el-radio-group
        v-else-if="field.type == 'radio'"
        v-model="form.data[field.id]"
        :disabled="field.disabled"
      >
        <el-radio
          v-for="(op,i) of field.options"
          :key="i"
          :label="op.value"
        >{{ op.name }}</el-radio>
      </el-radio-group>
      <!--   下拉选择框     -->
      <el-select
        v-else-if="field.type == 'select'"
        :placeholder="'请选择' + field.lable"
        :title="field.placeholder"
        :disabled="field.disabled"
        filterable
        clearable
        remote
        default-first-option
        :style="{ width: (field.width ? field.width : 200) + 'px' }"
        :remote-method="field.search ? (val) => { filterSelect(val, field) } : undefined"
        @change="selectChange(field)"
        v-model="form.data[field.id]"
      >
        <el-option
          v-for="(op,i) of field.search ? optionsFilter(field.options, optionReload) : field.options"
          :key="i"
          :label="op.name"
          :value="op.value"
        >
          <span style="float: left">{{ op.name }}</span>
          <span
            v-if="op.title"
            style="float: right; color: #8492a6; font-size: 13px"
          >{{ op.title }}</span>
        </el-option>
      </el-select>
      <!--   多选框     -->
      <el-checkbox-group
        v-else-if="field.type == 'checkbox'"
        :disabled="field.disabled"
        v-model="form.data[field.id]"
      >
        <el-checkbox
          v-for="(op,i) of field.options"
          :key="i"
          :value="op.value"
          @change="checkboxChange(field, op)"
        >{{op.name}}</el-checkbox>
      </el-checkbox-group>
      <!--  描述列表      -->
      <el-descriptions
        v-else-if="field.type == 'descriptions'"
        :column="3"
        size="medium"
        border
        :disabled="field.disabled"
      />
      <!-- 文件上传 -->
      <file-uploader
        v-else-if="'file,files,image,images'.includes(field.type)"
        v-model="form.data[field.id]"
        :type="field.type"
        :upload="$config.BASE_URL + '/file/upload'"
        :accept="field.accept"
        :request-data="field.requestData"
        :limit="field.limit ? field.limit : 1"
        @change="inputChange(field)"
      />
      <!--  代码编辑器      -->
      <code-editor
        v-else-if="field.type=='code'"
        v-model="form.data[field.id]"
        style="min-height: 300px;"
        :style="{ height: field.height ? field.height + 'px' : undefined }"
        :cm-mode="field.mode"
        :line-wrapping="field.wrap"
        :read-only="field.disabled"
        @change="codeChanged(arguments[0], field)"
      />
      <!--  固定值      -->
      <div v-else-if="field.type=='span'">
        <span>{{form.data[field.id]}}</span>
      </div>
      <!--  普通表单      -->
      <el-input
        v-else
        :type="field.type"
        v-model="form.data[field.id]"
        :placeholder="field.placeholder"
        :title="field.placeholder"
        :disabled="field.disabled"
        @change="inputChange(field)"
        :rows="field.rows"
      />
    </el-form-item>
    <div
      v-if="showConfirm"
      class="submit-container"
    >
      <el-button
        type="primary"
        @click="submit"
      >确 定</el-button>
    </div>
  </el-form>
</template>

<script>
import FileUploader from './FileUploader.vue';
import CodeEditor from './CodeEditor.vue'

var limit = (rule, value, callback) => {
  const min = rule.limit.min
  const max = rule.limit.max
  const require = rule.required
  const type = rule.type
  const lable = rule.lable
  if ((value === undefined || value === '' || value === ' ') && require) {
    return callback(new Error(lable + '不能为空'))
  }
  if (type === 'number') {
    if (min > value) {
      return callback(new Error(lable + '不能小于' + min))
    }
    if (max < value) {
      return callback(new Error(lable + '不能大于' + max))
    }
  } else {
    if (value) {
      if (min > value.length) {
        return callback(new Error(lable + '不能小于' + min + '字符'))
      }
      if (max < value.length) {
        return callback(new Error(lable + '不能大于' + max + '字符'))
      }
    }
  }
  callback()
};
export default {
  components: {
    FileUploader, CodeEditor
  },
  props: {
    showConfirm: {
      type: Boolean,
      default: true
    },
    labelWidth: {
      type: Number,
      default: 100
    },
    fields: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    fields () {
      this.$nextTick(() => {
        this.showForm = true
      })
    }
  },
  data: () => {
    return {
      showForm: false,
      optionReload: true,
      form: {
        rules: {},
        data: {},
      },

      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick (picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick (picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      rules: ['validator', 'trigger', 'required', 'message', 'type', 'min', 'max', 'enum', 'len', 'whitespace', 'limit', 'lable'],
      types: ['string', 'number', 'boolean', 'integer', 'float', 'array', 'enum', 'url', 'email', 'method', 'regexp', 'object', 'hex'],
    }
  },
  filters: {
    fileTypeIconImage(filename) {
      const fileicons = {
        apk: require('@/assets/images/file_type/apk.png'),
        bin: require('@/assets/images/file_type/bin.png'),
        doc: require('@/assets/images/file_type/doc.png'),
        docx: require('@/assets/images/file_type/doc.png'),
        exe: require('@/assets/images/file_type/exe.png'),
        mp4: require('@/assets/images/file_type/movie.png'),
        avi: require('@/assets/images/file_type/movie.png'),
        mp3: require('@/assets/images/file_type/mp3.png'),
        wav: require('@/assets/images/file_type/mp3.png'),
        m4a: require('@/assets/images/file_type/mp3.png'),
        pcm: require('@/assets/images/file_type/mp3.png'),
        pdf: require('@/assets/images/file_type/pdf.png'),
        ppt: require('@/assets/images/file_type/ppt.png'),
        sql: require('@/assets/images/file_type/sql.png'),
        xls: require('@/assets/images/file_type/xls.png'),
        xlsx: require('@/assets/images/file_type/xls.png'),
        zip: require('@/assets/images/file_type/zip.png'),
        rar: require('@/assets/images/file_type/zip.png'),
        '7z': require('@/assets/images/file_type/zip.png'),
        others: require('@/assets/images/file_type/file.png')
      }
      if (filename && filename.includes('.')) {
        const filetype = filename.substring(filename.lastIndexOf('.')+1)
        const image = fileicons[filetype]
        return image ? image : fileicons.others
      } else {
        return fileicons.others
      }
    },
    parseFileList(arr) {
      if (Array.isArray(arr)) {
        return arr.map(e => { return {src: e} })
      } else if (arr) {
        return [{src: arr}]
      } else {
        return []
      }
    }
  },
  methods: {
    calculateShow(show, data) {
      if (typeof show == 'undefined') {
        return true;
      }
      if (typeof show == 'boolean') {
        return show;
      }
      if (typeof show == 'function') {
        return show(data);
      }
    },
    optionsFilter (ops) {
      const arr = []
      for (const r of ops) {
        if (r.show) {
          arr.push(r)
        }
      }
      return arr
    },

    inputChange (field) {
      if (field.change) {
        field.change(field.id, this.form.data)
      }
    },
    checkboxChange (field, curop) {
      if (field.change) {
        field.change({
          id: field.id,
          option: curop,
          remove: this.form.data[field.id].includes(curop.value),
          form: this.form.data
        })
      }
      if (!this.form.data[field.id]) {
        this.form.data[field.id] = []
      }
    },

    handleAddImg (event, field) {
      event.field = field.id
      event.data = this.form.data
      
      let formData = new FormData
      formData.append('files', event.file)
      formData.append('type', 'image')
      this.$request('/file/upload', formData).then(resp => {
        let imgId = resp.data.id
        if (field.limit == 1) {
          event.data[event.field] = this.$config.BASE_URL + '/file/download?id=' + imgId
          event.success(this.$config.BASE_URL + '/file/download?id=' + imgId)
        } else {
          if (!event.data[event.field]) {
            event.data[event.field] = []
          }
          event.data[event.field].push(this.$config.BASE_URL + '/file/download?id=' + imgId)
          event.success(this.$config.BASE_URL + '/file/download?id=' + imgId)
        }
      })
    },
    handleDelImg (event, field) {
      event = {
        field: field.id,
        data: this.form.data,
        index: event.index,
        success: event.success
      }

      event.data[event.field].splice(event.index, 1)
      event.success()
    },
    handleChangeName (event, field) {
      const obj = {
        name: event[0],
        index: event[1],
        field: field.id,
        data: this.form.data
      }
      this.$emit('changeName', obj)
    },
    selectChange (field) {
      if (field.change) {
        field.change(field.id, this.form.data)
      }
    },
    filterSelect (val, field) {
      for (const item of field.options) {
        item.show = item.title ? (item.name + item.title).includes(val) : item.name.includes(val)
      }
      this.optionReload = !this.optionReload
      this.$forceUpdate()
    },
    codeChanged (code, field) {
      if (field.change) {
        field.change(code)
      }
    },
    getImgsSrc (field) {
      if (Array.isArray(this.form.data[field.id])) {
        return this.form.data[field.id]
      }
      if (!this.form.data[field.id]) {
        return []
      }
      if (typeof this.form.data[field.id] == 'string') {
        return [this.form.data[field.id]]
      }
      return field.parse ? field.parse(field.id, this.form.data) : []
    },
    handleFileUpload(event, field) {
      let formData = new FormData
      formData.append('files', event.file)
      formData.append('type', 'file')
      for (const k in event.data ? event.data : {}) {
        formData.append(k, event.data[k])
      }
      this.$request('/file/upload', formData).then(resp => {
        let imgId = resp.data.id
        if (field.limit == 1) {
          this.form.data[field.id] = this.$config.BASE_URL + '/file/download?id=' + imgId
        } else {
          if (!this.form.data[field.id]) {
            this.form.data[field.id] = []
          }
          this.form.data[field.id].push(this.$config.BASE_URL + '/file/download?id=' + imgId)
        }
      })
    },
    handleDownload(file) {
      window.open(file.src)
    },
    handleRemove(file, field) {
      if (Array.isArray(this.form.data[field.id])) {
        this.form.data[field.id] = this.form.data[field.id].filter(e => e != file.src)
      } else {
        this.form.data[field.id] = undefined
      }
    },


    submit () {
      this.$refs['data-form'].validate((success) => {
        if (success) {
          this.$emit('submit', this.form.data)
        } else {
          this.$message.error('请按要求填写字段！')
        }
      })
    },
    filterProp (obj) {
      const keys = Object.keys(obj)
      const res = {}
      for (const k of keys) {
        if (this.rules.includes(k)) {
          if (k == 'type') {
            if (this.types.includes(obj[k])) {
              res[k] = obj[k]
            }
          } else {
            res[k] = obj[k]
          }
        }
      }
      return res
    },
    defaultValue (data, type) {
      return data != undefined ? data : type == 'array' ? [] : undefined
    },
    show (data) {
      this.showForm = false
      this.$nextTick(() => {
        this.form.rules = {}
        if (data) {
          for (const r of Object.keys(data)) {
            this.form.data[r] = data[r]
          }
        }
        for (const r of this.fields) {
          this.form.data[r.id] = data ? (r.filter ? r.filter(data) : this.defaultValue(data[r.id], r.dataType)) : this.defaultValue(undefined, r.dataType)
          if (typeof r.limit == 'object') {
            r.validator = limit
          }
          if (r.type == 'select') {
            this.filterSelect('', r)
          }

          const rule = this.filterProp(r)
          rule.trigger = 'blur'
          rule.type = r.dataType ? r.dataType : rule.type
          rule.required = r.show == false ? false : r.required
          this.form.rules[r.id] = [rule]
        }
        this.$nextTick(() => {
          if (this.$refs['data-form']) {
            this.$refs['data-form'].clearValidate()
            this.showForm = true
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.submit-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.upload-item{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  .icon {
    width: 105px;
    height: 105px;
  }
}
</style>